import { useState } from 'react';
import { getIcon } from '../../../utils/iconRegistry';
import styles from '../PropertyPanel.module.css';

const COMMON_ICONS = [
  'FaHome', 'FaBriefcase', 'FaUserTie', 'FaRobot', 'FaEnvelope',
  'FaTshirt', 'FaDumbbell', 'FaFireAlt', 'FaWifi',
  'FaReact', 'FaMobileAlt', 'FaDatabase',
  'FaLinkedin', 'FaGithub', 'FaDownload', 'FaCertificate',
  'FaArrowRight', 'FaPlay', 'FaPause', 'FaRedo',
  'FaPalette', 'FaFont', 'FaImage', 'FaSave', 'FaEdit',
];

function IconPickerField({ label, value, onChange }) {
  const [isOpen, setIsOpen] = useState(false);
  const CurrentIcon = value ? getIcon(value) : null;

  return (
    <div className={styles.field}>
      <span className={styles.fieldLabel}>{label}</span>
      <button className={styles.iconPickerBtn} onClick={() => setIsOpen(!isOpen)}>
        {CurrentIcon ? <CurrentIcon /> : '—'}
        <span>{value || 'Select icon'}</span>
      </button>
      {isOpen && (
        <div className={styles.iconGrid}>
          {COMMON_ICONS.map((name) => {
            const Icon = getIcon(name);
            return Icon ? (
              <button
                key={name}
                className={`${styles.iconOption} ${value === name ? styles.iconOptionActive : ''}`}
                onClick={() => { onChange(name); setIsOpen(false); }}
                title={name}
              >
                <Icon />
              </button>
            ) : null;
          })}
        </div>
      )}
    </div>
  );
}

export default IconPickerField;
